import {Modal} from "../../../../styleguide/js/components/modal/modal";

export class ModalExampleComponent extends Modal {
    setOptions() {
        const options = {};
        if (this.element.data('modaal-type')) {
            options['type'] = this.element.data('modaal-type');
        }
        if(options['type']==='ajax'){
          options['ajax_success'] = function(target){
            window.pew.enhanceRegistry(target[0]);
          }
        }
        super.setOptions(options);
    }
}

window.pew.addRegistryEntry({key: 'wdf-modal-example', domSelector: '.wdf-modal', classDef: ModalExampleComponent});




// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Modal/js/modal-component.js